<template>
  <v-badge
      color="red"
      :value="content"
      :content="content"
      overlap
  >
    <v-btn  dark icon text :to="{name:'CustomerOrderPage'}"> <v-icon>shopping_cart</v-icon></v-btn>
  </v-badge>

</template>

<script>
export default {
  name: "ShoopingCartButton",
  computed: {
    content(){
      return this.$store.getters.orderSystem.cartService.getItemsQuantity
    }
  }
}
</script>

<style scoped>

</style>
